<i18n locale="en">
{
  "dismiss": "Dismiss",
  "edit-template": "Edit template"
}
</i18n>

<template>
  <div class="align-center flex-row justify-end gap-3">
    <OwnButton :text="t('dismiss')" variant="secondary" @click="onDismiss" />
    <OwnButton
      :text="t('edit-template')"
      variant="primary"
      @click="goToBuilder"
    />
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'

import { OwnButton } from '@/ui/OwnButton'

import { emailBuilderRouteManager } from '../../../builders/email/emailBuilderRouter'
import { textBuilderRouteManager } from '../../../builders/text/textBuilderRouter'

export default {
  name: 'InvalidConfigurationFooter',
  components: { OwnButton },
  props: {
    campaign: { type: Object, default: null },
  },
  emits: ['close'],
  setup() {
    const { t } = useI18n()

    return { t }
  },
  methods: {
    async goToBuilder() {
      const routeManager =
        this.campaign.transport === 'sms'
          ? textBuilderRouteManager
          : emailBuilderRouteManager

      const resourcePageRoute = await routeManager.editResourcePage(
        this.campaign.id
      )

      await this.$router.push(resourcePageRoute)

      this.$emit('close') // Close the dialog if already on the builder page
    },
    onDismiss() {
      this.$emit('close')
    },
  },
}
</script>
